export default __webpack_public_path__ + "static/media/received-request.52dfafd0.svg";